/**
 * Parse composite "Time / Phase" labels from debriefing guide JSON.
 * e.g. "00:05:52 – Landing clearance / short final" → timestamp + description
 */

const TIME_PHASE_SPLIT =
  /^(?:\[)?(\d{1,2}:\d{2}(?::\d{2})?)(?:\])?\s*(?:[-–—/|]\s*)?(.*)$/;

export function splitTimePhase(timePhase: string): {
  timestamp: string;
  description: string;
} {
  const trimmed = timePhase.trim();
  const match = trimmed.match(TIME_PHASE_SPLIT);

  if (!match) {
    return { timestamp: '', description: trimmed };
  }

  return {
    timestamp: match[1] ?? '',
    description: (match[2] ?? '').trim(),
  };
}
